import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Chip, Tooltip, Typography } from '@mui/material'
import { CheckCircle, Cancel } from '@mui/icons-material'
import HsChipList from '../../mailTemplate/src/components/atomic/molecules/HsChipList'

import { useGlobalStoreData } from '../../store/globalStore'

const CampaignInfo = ({ campaignDetails }) => {
  const { t } = useTranslation()

  const user = useGlobalStoreData.user()

  let canSend = user?.canSend
  let canReceive = user?.canReceive

  if (user?.roles?.includes('B2B_PERSONNEL')) {
    const followedAccount = user?.followedB2bAccountIds?.[campaignDetails?.b2bAccountId]
    canSend = followedAccount?.canSend || false
    canReceive = followedAccount?.canReceive || false
  }

  const showMailStatus = canSend != null || canReceive != null

  if (!campaignDetails) return null

  const SectionTitle = ({ children }) => (
    <Typography
      variant="caption"
      sx={{
        fontSize: '0.6rem',
        fontWeight: 600,
        color: 'text.disabled',
        textTransform: 'uppercase',
        letterSpacing: 0.5,
        textAlign: 'center'
      }}
    >
      {children}
    </Typography>
  )

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1.5 }}>
      {/* Mail Status */}
      {showMailStatus && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          <SectionTitle>{t('mailTemplate.campaigns.mailStatus.label')}</SectionTitle>
          <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'center' }}>
            <Tooltip
              title={canSend
                ? t('mailTemplate.campaigns.mailStatus.canSendTooltip')
                : t('mailTemplate.campaigns.mailStatus.cannotSendTooltip')}
              arrow
            >
              <Chip
                icon={canSend
                  ? <CheckCircle sx={{ fontSize: '0.75rem' }}/>
                  : <Cancel sx={{ fontSize: '0.75rem' }}/>}
                label={t('mailTemplate.campaigns.mailStatus.send')}
                size="small"
                sx={{
                  fontWeight: 500,
                  borderRadius: 1.5,
                  height: 22,
                  fontSize: '0.7rem',
                  backgroundColor: canSend ? '#e8f5e9' : '#ffebee',
                  color: canSend ? '#2e7d32' : '#c62828',
                  '& .MuiChip-icon': {
                    color: canSend ? '#2e7d32' : '#c62828'
                  }
                }}
              />
            </Tooltip>
            <Tooltip
              title={canReceive
                ? t('mailTemplate.campaigns.mailStatus.canReceiveTooltip')
                : t('mailTemplate.campaigns.mailStatus.cannotReceiveTooltip')}
              arrow
            >
              <Chip
                icon={canReceive
                  ? <CheckCircle sx={{ fontSize: '0.75rem' }}/>
                  : <Cancel sx={{ fontSize: '0.75rem' }}/>}
                label={t('mailTemplate.campaigns.mailStatus.receive')}
                size="small"
                sx={{
                  fontWeight: 500,
                  borderRadius: 1.5,
                  height: 22,
                  fontSize: '0.7rem',
                  backgroundColor: canReceive ? '#e8f5e9' : '#ffebee',
                  color: canReceive ? '#2e7d32' : '#c62828',
                  '& .MuiChip-icon': {
                    color: canReceive ? '#2e7d32' : '#c62828'
                  }
                }}
              />
            </Tooltip>
          </Box>
        </Box>
      )}

      {/* HS Codes */}
      {campaignDetails?.hsCodes?.length > 0 && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          <SectionTitle>{t('personnel.marketChanges.hsCodes')}</SectionTitle>
          <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'center' }}>
            <HsChipList hsArr={campaignDetails?.hsCodes} visibleCount={3}/>
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default CampaignInfo
